
module.exports = unrepr = function(s) {
	try {
		return eval('(' + s + ')');
	}
	catch(err) {
		return null;
	}
}

